@if (!isLandscape) {
  <section class="overlay" aria-label="Orientation warning">
    <div class="content">
      <div class="icons">
        <mat-icon class="icon">screen_lock_rotation</mat-icon>
        <mat-icon class="icon">arrow_right_alt</mat-icon>
        <mat-icon class="icon">stay_current_landscape</mat-icon>
      </div>
      <p class="message">
        We want to deliver this assessment in the best possible way.
        <br />
        Please rotate your device to landscape mode.
      </p>
    </div>
  </section>
}